"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _immer = _interopRequireDefault(require("immer"));

var _openAction = require("../actions/open-action");

var _closeAction = require("../actions/close-action");

var _hideAction = require("../actions/hide-action");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var initialState = {
  "hamburgerMenuState": "d-none"
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _immer["default"])(state, function (draft) {
    switch (action.type) {
      case _openAction.OPEN_MENU:
        draft.hamburgerMenuState = "open";
        return draft;

      case _closeAction.CLOSE_MENU:
        draft.hamburgerMenuState = "closed";
        return draft;

      case _hideAction.HIDE_MENU:
        draft.hamburgerMenuState = "d-none";
        return draft;

      default:
        return state;
    }
  });
};

exports["default"] = _default;